import { stats } from "@/mocks/home";

export default function DataBoard() {
  return (
    <section className="bg-accent-950">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 md:grid-cols-4">
          {stats.map((s, i) => (
            <div key={s.label} className="flex items-center gap-3 md:flex-col md:items-start md:gap-2">
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-lg text-background-50 ${i % 2 === 0 ? "bg-primary-500" : "bg-secondary-500"}`}>
                <i className={s.icon}></i>
              </span>
              <div>
                <p className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{s.value}</p>
                <p className="mt-0.5 text-xs text-accent-300 md:text-sm">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}